<script>
  export let today;
  export let limit = 13;

  import { format, fridaysThe13th } from "./dates.mjs";
  import DateList from "./DateList.svelte";
  import RelativeDate from "./RelativeDate.svelte";

  const _fridays = fridaysThe13th(today);

  const fridays = [];
  for (let index = 0; index < limit; index++) {
    let f = _fridays.next().value;
    fridays.push(f);
  }
  const [firstFriday, ...moreFridays] = fridays;
</script>

<main>
  {#if today.day === 13 && today.dayOfWeek === 5}
    <h1 style="color: red;">Today is Friday the 13th.</h1>

    <p>This will happen again on:</p>

    <DateList days={fridays} />
  {:else}
    <h1>The next Friday the 13th is on</h1>

    <div class="first">
      {format(firstFriday)}
      <div class="relative">
        in <RelativeDate date={firstFriday} relativeTo={today} />
      </div>
    </div>

    <p>This will happen again on:</p>

    <DateList dates={moreFridays} />
  {/if}
</main>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }

  h1 {
    font-size: 2em;
    font-weight: 100;
  }

  .first {
    font-size: 4em;
    margin-bottom: 1em;
  }

  .relative {
    font-size: 0.25em;
    font-weight: 50;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
